/* eslint-disable no-undef */
<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" class="demo-inline-form" :model="search_subAg">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="代理商编号" style="width:160px;" v-model="search_subAg.FAgentId" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="代理商名称" style="width:160px;" v-model="search_subAg.fTitle" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="search_subAg.FAgentLevel" placeholder="代理商等级" clearable @change="setAgentLevel" prop="FAgentLevel" >
              <el-option v-for="item in agent_level_list" :key="item.key" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="手机号" style="width:150px;" v-model="search_subAg.FMobile" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="业务员账号" style="width:150px;" v-model="search_subAg.FOperator" auto-complete="off" :disabled="roleName === 'operator'"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="状态" style="width:140px;" v-model="search_subAg.FBlockStatus" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="冻结" value="1"></el-option>
              <el-option label="注销" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="buttomSearch" :loading="checkLoading" label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table stripe style="width:100%" align="center" v-loading="saleLoading" :data="subAg_list" :header-cell-style="{background:'#FAFAFA'}"  @sort-change="tableSortChange1">
        <el-table-column prop="fcreateTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="fAgentId" label="代理商编号" align="center"></el-table-column>
        <el-table-column prop="fTitle" label="代理商名称" align="center"></el-table-column>

        <el-table-column prop="fAgentParentId" label="直属代理商编号" align="center"></el-table-column>

        <el-table-column prop="fAgentLevel" label="代理商等级" align="center" :formatter="formatLevel"></el-table-column>
        <el-table-column prop="fOperatorName" label="发展业务员" align="center"></el-table-column>
        <el-table-column prop="developMerchantNum" label="发展商户数（个）" align="center"></el-table-column>
        <el-table-column prop="t0SettlementStateStr" label="是否开通D0交易" align="center"></el-table-column>
        <el-table-column prop="FBlockStatus" label="状态" align="center" :formatter="formatStatus">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" :context="_self">
          <template slot-scope="scope">
            <auth-button opt="edit" type="text" v-if="scope.row.fAgentParentId === agentId" label="编辑" @click.native="handleSale(scope.$index, scope.row)"></auth-button>
            <auth-button opt="details" type="text" label="查看" v-if="scope.row.fAgentParentId !== agentId" @click.native="handleSale(scope.$index, scope.row)"></auth-button>
            <auth-button opt="edit" type="text" v-if="scope.row.isShowT0 && scope.row.t0SettlementState === 0" @click.native="goT0Settle(scope.row)" label="开启D0结算"></auth-button>
            <auth-button opt="edit" type="text" v-if="scope.row.isShowT0 && scope.row.t0SettlementState === 1" @click.native="goT0Settle(scope.row)" label="关闭D0结算"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage"></el-pagination>
    </el-col>

    <!-- 编辑界面 -->
    <el-dialog title="代理商信息修改" :visible.sync="dialogFormVisible" class="editDialog" :width="ruleType === 0? '550px' : '1250px'" @close="closeViewDialog">
      <div v-if="!dialogDisabled && agentLevel === 1">
        <el-button type="primary" @click="showAgentInfo()">代理商信息</el-button>
        <el-button type="primary" @click="stateControl()">状态控制</el-button>
      </div>
      <div v-show="editDialogContent === 'agentInfo'">
        <el-form label-width="100px" :model="baseInfo" :rules="rule_data" ref="baseInfo" >
          <h3 size="medium">基本信息
            <ViewAccount  @success="(account)=>{
                this.baseInfo.fAgentAccount = account.fAgentAccount
                this.baseInfo.fTitle = account.fName
                this.baseInfo.fMobile = account.fMobile
                this.baseInfo.fBankAccount = account.fBankAccount
                this.baseInfo.fBankCardid = account.fBankCardid
              }"
              :agentId="baseInfo.fAgentId"
              :isReset="dialogFormVisible" />
          </h3>
          <el-form-item label="登录账号" prop="fAgentAccount">
            <el-input v-model="baseInfo.fAgentAccount" style="width: 30%" placeholder="8~20位数字或字母" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="代理商名称" prop="fTitle">
            <el-input v-model="baseInfo.fTitle" style="width: 30%" placeholder="请输入代理商名称" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="绑定手机" prop="fMobile">
            <el-input v-model="baseInfo.fMobile" style="width: 30%" placeholder="请输入绑定手机" :disabled="true" @focus="needHideInfoInputFocus('fMobile')"></el-input >
          </el-form-item>
        </el-form>
        <el-form ref="pos" label-width="80px" label-position="left">
          <h3 size="medium" >成本信息</h3>
          <el-form-item label="成本模板" v-if="!dialogDisabled">
            <el-select v-model="selectedTemplate" placeholder="请选择模板" @change="rateTemplateSelectChange">
              <el-option label="自定义" :value="-1" :key="-1"></el-option>
              <el-option :label="template.name" :value="template.id" v-for="template in rateTemplateList" :key="template.id"></el-option>
            </el-select>
            <div>提示:成本信息无变更，无需选择</div>
          </el-form-item>
          <el-form-item label="分成比例" size="large" v-show="ruleType === 0">
            <el-input type="text" v-model="baseInfo.fLowerDivideCent" style="width: 30%" :disabled="dialogDisabled"><template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item label="刷卡成本" size="large" label-width="50px;" v-show="ruleType === 1">
            <!-- <el-button type="primary" :inline="true" @click="setDefaultRate"  plain :disabled = dialogDisabled>使用默认成本</el-button> -->
          </el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType === 1">
            <el-table :data="cardTable" border size="small" align="center" style="width:900px;" :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)"/><span>%</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" label="D+0费率" width="150" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)" />
                    <span slot="suffix">%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="D+0单笔手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d0Fixed" @blur="onRateBlur(scope.row.d0Fixed)" v-if="scope.row.d0Fixed !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="额外收取下级分成比例" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" @blur="onRateBlur(scope.row.posLower)"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="扫码成本" size="large" label-width="50px;" v-show="ruleType === 1" style="margin-top: 30px"></el-form-item>
          <div class="qr infoAgentForm" v-loading="saleLoading" v-show="ruleType === 1">
            <div style="margin-top: -10px">
              <el-form-item label="额外收取下级分成比例" size="large" label-width="50px;">
                <div>
                  <input class="scanLowerDivideCent" @blur="onRateBlur('scanLowerDivideCent')" style="width: 200px"/>
                  <span style="height: 40px;line-height: 40px;">%</span>
                </div>
              </el-form-item>
            </div>
            <el-table :data="scanWechatTable" border size="small" align="center" style="width:1080px;" :cell-class-name="goodsInfo">
              <el-table-column prop="type" label="微信费用" align="center">
                <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1 !== '--'">
                      <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column v-if='isShowD0' prop="d0" label="D+0费率" align="center">
                  <template slot-scope="scope">
                    <div>
                      <input :class='scope.row.d0' @blur="onRateBlur(scope.row.d0)" />
                      <span>%</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showWechat" style="width:810px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="scanWechatMulti" border size="small" align="center" style="width:1080px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                        <input :class="scope.row.typeLetterL + '_' + scope.row.d1L"
                          :disabled="defaultDataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                          @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                        <input
                          :class="scope.row.typeLetterR + '_' + scope.row.d1R"
                          :disabled="defaultDataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                          @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="showRihua" style="width:360px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="服饰日化费率" name="1">
                <el-row class="row">
                  <el-col class="item">费用类型</el-col>
                  <el-col class="item">D+1费率</el-col>
                </el-row>
                <el-row class="row">
                  <el-col class="item">服饰日化-借记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="rihuaEntity.wxCategoryDebitCommissionD1">
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row  class="row">
                  <el-col class="item">服饰日化-贷记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="rihuaEntity.wxCategoryCreditCommissionD1">
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
            <el-table :data="scanAlipayTable" border size="small" align="center" style="width:1080px;">
              <el-table-column prop="type" label="支付宝费率" align="center">
                <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1 !== '--'">
                      <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column prop="d0" v-if='isShowD0' label="D+0费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d0 !== '--'">
                      <input :class='scope.row.d0' @blur="onRateBlur(scope.row.d0)" />
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showAlipay" style="width:810px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="scanAlipayMulti" border size="small" align="center" style="width:1080px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                        <input
                          :class="scope.row.typeLetterL + '_' + scope.row.d1L"
                          :disabled="defaultDataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                          @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                        <input
                          :class="scope.row.typeLetterR + '_' + scope.row.d1R"
                          :disabled="defaultDataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                          @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
          <el-form-item label="银联二维码" size="large" label-width="50px;" v-show="ruleType === 1"></el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType === 1">
            <el-table :data="unionpayTable" border size="small" align="center" style="width:800px;" :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率>1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1 !== '--'">
                    <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="180" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Level2" label="D+1费率≤1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1Level2 !== '--'">
                    <input :class="scope.row.d1Level2" @blur="onRateBlur(scope.row.d1Level2)"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" v-if='isShowD0' label="D+0费率>1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" @blur="onRateBlur(scope.row.d0)"/>
                    <!-- <el-input-number :controls="false" :max='0.6' v-model="defaultDataParam[scope.row.d0]" :class='defaultDataParam[scope.row.d0]' @blur="onRateBlur(scope.row.d0)">
                    </el-input-number> -->
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Level2" v-if='isShowD0' label="D+0费率≤1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0Level2 !== '--'">
                    <input :class="scope.row.d0Level2" @blur="onRateBlur(scope.row.d0Level2)"/>
                    <!-- <el-input-number :controls="false" :max='0.6' v-model="defaultDataParam[scope.row.d0Level2]" :class='defaultDataParam[scope.row.d0Level2]' @blur="onRateBlur(scope.row.d0Level2)"/> -->
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="posLower" label="额外收取下级分成比例" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" @blur="onRateBlur(scope.row.posLower)"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="扫码点餐类扫码费率" size="large" label-width="50px;" style="margin-top: 10px"></el-form-item>
          <div class="two-table">
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率</div>
              </div>
              <div class="row">
                <div class="item left">微信</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1WeixinIncrementCommission" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">支付宝</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1AlipayIncrementCommission" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率&gt;1000元</div>
                <div class="item">D+1封顶手续费</div>
                <div class="item">D+1费率≤1000元</div>
              </div>
              <div class="row">
                <div class="item left">借记卡</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayGt1000DebitIncrementRate" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayDebitIncrementMaxFee" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayDebitIncrementRate" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">贷记卡</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayGt1000CreditIncrementRate" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">——</div>
                <div class="item">
                  <el-input v-model="scanOrder.t1UnionpayCreditIncrementRate" class="LowerDivideCent" @change="subLowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form label-width="100px" :inline="true" >
          <h3 size="medium">结算信息（非单独入账可不填）</h3>
          <el-form-item label="账户类型" prop="FBankAccountType">
            <el-select v-model="baseInfo.fBankAccountType" style="width: 120px;" placeholder="" clearable :disabled="dialogDisabled">
              <el-option label="对私" :value="1"></el-option>
              <el-option label="对公" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户名" prop="fBankAccount">
            <el-input v-model="baseInfo.fBankAccount" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="开户人身份证" prop="fIdentityCard">
            <el-input v-model="baseInfo.fIdentityCard" :disabled="dialogDisabled" @focus="needHideInfoInputFocus('fIdentityCard')"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="fBankCardid">
            <el-input v-model="baseInfo.fBankCardid" :disabled="dialogDisabled" @focus="needHideInfoInputFocus('fBankCardid')"></el-input>
          </el-form-item>
          <el-form-item label="开户行" >
            <el-select style="width:150px;" placeholder="" clearable filterable v-model="baseInfo.fBankType" @change="setBankName" prop="fBankType" :disabled="dialogDisabled">
              <el-option v-for="item in bank_list" :key="item.F_bank_name_code" :label="item.F_bank_name" :value="item.F_bank_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行网点" >
            <el-select style="width:120px;" placeholder="请选择省" clearable filterable v-model="baseInfo.fBankArea" @change="setBankPro" prop="fBankArea" :disabled="dialogDisabled || !baseInfo.fBankType">
              <el-option v-for="item in pro_list" :key="item.F_bank_area_code" :label="item.F_bank_area" :value="item.F_bank_area"></el-option>
            </el-select>
            <el-select v-model="baseInfo.fBankCity" placeholder="请选择市" @change="setBankCity" clearable style="width: 120px;" prop="fBankCity" :disabled="dialogDisabled  || !baseInfo.fBankType">
              <el-option v-for="item in city_list" :key="item.F_bank_city_code" :label="item.F_bank_city" :value="item.F_bank_city"></el-option>
            </el-select>
            <el-select v-model="baseInfo.fBankPoint" placeholder="分行网点" @change="setBranch" clearable style="width: 120px;" prop="fBankPoint" :disabled="dialogDisabled  || !baseInfo.fBankType">
              <el-option v-for="item in branch_list" :key="item.F_branch_no" :label="item.F_branch_name" :value="item.F_branch_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预留手机号" prop="fBankMobile">
            <el-input v-model="baseInfo.fBankMobile" :disabled="dialogDisabled" @focus="needHideInfoInputFocus('fBankMobile')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="editDialogContent === 'stateControl'">
        <h3>状态控制</h3>
        <el-form ref="changeTradeStateform" label-width="100px" :model="changeTradeStateInfo" :rules="changeTradeStateRules">
          <el-form-item label="进件状态" prop="operateType">
            <el-select placeholder="请选择" v-model="changeTradeStateInfo.operateType">
              <el-option label="开通" value="1"></el-option>
              <el-option label="冻结" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改理由" prop="changeReason">
            <el-input class="form-input" type="textarea" :autosize="{ minRows: 2 }" :maxlength="50" placeholder="请从违规类型、造成的影响方面描述，50字以内" v-model="changeTradeStateInfo.changeReason"></el-input>
          </el-form-item>
          <div><i class="el-icon-warning"></i> 冻结后，下级服务商将无法进行商户进件操作，请谨慎操作</div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%" v-show="editDialogContent === 'agentInfo'">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editSubmit" :loading="addLoading" v-if="!dialogDisabled">修改</el-button>
      </span>
      <span slot="footer" class="dialog-footer" style="width:100%" v-show="editDialogContent === 'stateControl'">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleStateControlClick" :loading="addLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="isShowOpenT0SettleDialog"
      width="30%">
      <span v-if='selectedT0Entity.t0SettlementState === 0'>是否开通D0结算？</span>
      <span v-else>是否关闭D0结算？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowOpenT0SettleDialog = false">取 消</el-button>
        <el-button type="primary" @click="doOpenT0Settle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { hideBankCardNum, hideRealName, hidePhoneNum, hideIdCardNum } from '@/utils/hideSensitiveInfo.js'
// export default {InfoJs};
import { getSalesmanGroup, subAgentDetail, subAgentList, getSalesmanCitys, getSalesmanProcity, getAgFee, addSubAgent, getTemplateList, getTemplate, modifyAgentApplicationStatus, t0Settlement } from '@/api/partner'
import qs from 'qs' // 代理商成本、商户手续费默认封顶值
import ViewAccount from '@/components/ViewAccount'
import md5 from 'js-md5'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

const topRateNum = 50 // 代理商成本、商户费率默认封顶值
const topFeeNum = 500
export default {
  name: 'AgentInfo',
  components: {
    ViewAccount
  },
  data () {
    return {
      scanOrder: {
        t1WeixinIncrementCommission: '',
        t1AlipayIncrementCommission: '',
        t1UnionpayCreditIncrementRate: '',
        t1UnionpayDebitIncrementRate: '',
        t1UnionpayDebitIncrementMaxFee: '',
        t1UnionpayGt1000CreditIncrementRate: '',
        t1UnionpayGt1000DebitIncrementRate: ''
      },
      isShowD0: true,
      selectedT0Entity: {},
      isShowOpenT0SettleDialog: false,
      subAg_list: [],
      domain: 'https://baseweb.lszzg.com/',
      bank_list: [],
      pro_list: [],
      city_list: [],
      branch_list: [],
      areas: [],
      citys: [],
      data: [],
      t1DebitCommission: '',
      proCity_list: [],
      cityForm: {
        f_custom: '0',
        f_parent_code: '',
        f_code: '',
        f_name: ''
      },
      tableData1: [],
      dataParam: {},
      defaultDataParam: {
        extraFeeRate: {
          alipay: {
            activityFee0: '', // 活动0
            activityFee1: '', // 活动1
            bluesea: '', // 蓝海
            online: ''// 线上
          },
          wechat: {
            collegeCanteen: '', // 高校食堂
            insurance: '', // 保险
            oasis: '', // 绿洲
            online: '', // 线上
            privateSchool: '', // 私立学校
            publicPayment: '', // 公缴
            publicWeal: '' // 公益
          }
        }
      },
      agent_level_list: [],
      agentId: '',
      checkLoading: false,
      addLoading: false,
      seloading: false,
      saleLoading: false,
      editSaleLoading: false,
      table_type: 'sale',
      form_type: 'sale',
      salesNum: '',
      search_group_list: [],
      comeTime: '',
      operator: '编辑',
      downCtr: true,
      dialogDisabled: false,
      totaldata: {},
      editSaleForm: {},
      roleName: '',
      // 搜索表单信息
      search_subAg: {
        startTime: '',
        endTime: '',
        FCreateTime: '',
        FAgentId: '',
        FName: '',
        FBlockStatus: '',
        pageNo: '',
        pageSize: '',
        totalCount: '',
        FAgentLevel: '',
        FOperator: ''
      },
      viewAgent: {
        show: false
      },
      dialogFormVisible: false,
      rule_data: {
        FAgentAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入登录账号'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入8-20位数字或字母'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FAgentPassword: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          }
        }],
        fName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value) || value.includes('*')) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fTitle: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入代理商姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,40}$/.test(value) || value.includes('*')) {
                callback()
              } else {
                callback(new Error('请输入2-40位的中文代理商名称'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value)) && !value.includes('*')) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FBankAccountType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择账户类型'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        fBankAccount: [{
          validator: (rule, value, callback) => {
            console.log(value)
            if (value === '') {
              callback(new Error('请输入开户名'))
            } else {
              if (this.baseInfo.fBankAccountType === 1) {
                if (/^[\u4e00-\u9fa5()（）]{2,6}$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入2-6位中文姓名'))
                }
              } else {
                if (/^[\u4e00-\u9fa5()（）]{2,40}$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入2-40位开户名'))
                }
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FIdentityCard: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号码'))
            } else {
              if (!(/^\d{17}(\d|\w){1}$/.test(value)) && !value.includes('*')) {
                callback(new Error('身份证号码输入有误'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCardid: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入银行卡号'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入开户行'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankArea: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入省名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCity: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入市名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankPoint: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入区名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value)) && !value.includes('*')) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }]
      },
      groupIdDisabledInput: false,
      disabledInput: false,
      // 弹框信息
      addSale: {
        show: false,
        flag: false
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      props: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 新增界面数据
      editForm: {
        FAgentAccount: '',
        FAgentPassword: '',
        FName: '',
        FTitle: '',
        FMobile: '',
        FBankAccountType: '',
        FBankAccount: '',
        FIdentityCard: '',
        FBankCardid: '',
        FBankType: '',
        FBankArea: '',
        FBankCity: '',
        FBankPoint: '',
        FBankMobile: '',
        insertFlag: '1', // 新建
        t1DebitCommission: '',
        t1DebitMaxFee: '',
        t0DebitCommission: '',
        t1CreditCommission: '',
        t0CreditCommission: '',
        t1OverSeasCommission: '',
        t0OverSeasCommission: '',
        t0FixFee: '',
        posLowerDivideCent: '',
        t1WeixinCommission: '',
        t0WeixinCommission: '',
        t1AlipayCommission: '',
        t0AlipayCommission: '',
        t1UnionpayDebitRate: '',
        t0UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t0UnionpayCreditRate: '',
        t1UnionpayOverseasRate: '',
        t0UnionpayOverseasRate: '',
        unionLowerDivideCent: '',
        scanLowerDivideCent: '',
        FLowerDivideCent: '',
        extraFeeRate: ''
      },
      baseInfo: {
        fBankAccountType: '',
        fBankAccount: '',
        fIdentityCard: '',
        fBankCardid: '',
        fBankType: '',
        fBankArea: '',
        fBankCity: '',
        fBankPoint: '',
        fBankMobile: ''
      },
      pos: {
        t1DebitCommission: '',
        t1CreditCommission: '',
        t1OverSeasCommission: '',
        t1DebitMaxFee: '',
        t0DebitCommission: '',
        t0CreditCommission: '',
        t0OverSeasCommission: '',
        t0FixFee: '',
        lowerDivideCent: ''
      },
      scan: {
        t1WeixinCommission: '',
        t1AlipayCommission: '',
        t0WeixinCommission: '',
        t0AlipayCommission: '',
        scanLowerDivideCent: ''
      },
      unionpay: {
        t1UnionpayDebitRate: '',
        t0UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t0UnionpayCreditRate: '',
        t1UnionpayOverseasRate: '',
        t0UnionpayOverseasRate: '',
        unionLowerDivideCent: ''
      },
      ruleType: '',
      fRate: '',
      // addForm : {}
      editDialogContent: 'agentInfo',
      changeTradeStateInfo: {
        operateType: '',
        changeReason: ''
      },
      changeTradeStateRules: {
        operateType: [
          { required: true, message: '请选择要修改的交易状态', trigger: 'change' }
        ],
        changeReason: [
          { required: true, message: '请输入修改理由', trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' },
          { pattern: /^\S{1,50}$/, message: '修改理由不能超过50个字', trigger: 'blur' }
        ]
      },
      selectedTemplate: '',
      rateTemplateList: [],
      cardTable: [
        {
          type: '借记卡',
          d1: 't1DebitCommission',
          d1Max: 't1DebitMaxFee',
          d0: 't0DebitCommission',
          d0Fixed: 't0FixFee',
          posLower: 'posLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 't1CreditCommission',
          d1Max: '--',
          d0: 't0CreditCommission',
          d0Fixed: '--'
        },
        {
          type: '境外卡',
          d1: 't1OverSeasCommission',
          d1Max: '--',
          d0: 't0OverSeasCommission',
          d0Fixed: '--'
        }
      ],
      scanWechatTable: [
        {
          extraType: '线下（默认）',
          d1: 't1WeixinCommission',
          d0: 't0WeixinCommission',
          posLower: 'scanLowerDivideCent'
        }
      ],
      showWechat: [],
      showRihua: [],
      scanWechatMulti: [
        {
          extraTypeL: '绿洲',
          d1L: 'oasis',
          typeLetterL: 'wechat',
          extraTypeR: '公益',
          d1R: 'publicWeal',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '高校食堂',
          d1L: 'collegeCanteen',
          typeLetterL: 'wechat',
          extraTypeR: '公缴',
          d1R: 'publicPayment',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '私立中小幼',
          d1L: 'privateSchool',
          typeLetterL: 'wechat',
          extraTypeR: '保险',
          d1R: 'insurance',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'wechat',
          extraTypeR: '——',
          d1R: '--',
          typeLetterR: 'wechat'
        }
      ],
      scanAlipayTable: [
        {
          d1: 't1AlipayCommission',
          d0: 't0AlipayCommission',
          extraType: '线下（默认）'
        }
      ],
      showAlipay: [],
      scanAlipayMulti: [
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'alipay',
          extraTypeR: '蓝海活动',
          d1R: 'bluesea',
          typeLetterR: 'alipay'
        },
        {
          extraTypeL: '行业活动0',
          d1L: 'activityFee0',
          typeLetterL: 'alipay',
          extraTypeR: '行业活动1',
          d1R: 'activityFee1',
          typeLetterR: 'alipay'
        }
      ],
      unionpayTable: [
        {
          type: '借记卡',
          d1: 'fT1DebitCommissionBymillion',
          d1Max: 'fT1UnionpayDebitMaxCharge',
          d1Level2: 'fT1BelowDebitCommissionBymillion',
          d0: 'fT0DebitCommissionBymillion',
          d0Level2: 'fT0BelowDebitCommissionBymillion',
          posLower: 'unionLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 'fT1CreditCommissionBymillion',
          d1Max: '--',
          d1Level2: 'fT1BelowCreditCommissionBymillion',
          d0: 'fT0CreditCommissionBymillion',
          d0Level2: 'fT0BelowCreditCommissionBymillion'
        }
      ],
      rihuaEntity: {
        wxCategoryDebitCommissionD1: '', // 服饰日化-借记卡
        wxCategoryCreditCommissionD1: '' // 服饰日化-贷记卡
      },
      extraFeeRate: {
        alipay: {
          activityFee0: '', // 活动0
          activityFee1: '', // 活动1
          bluesea: '', // 蓝海
          online: ''// 线上
        },
        wechat: {
          collegeCanteen: '', // 高校食堂
          insurance: '', // 保险
          oasis: '', // 绿洲
          online: '', // 线上
          privateSchool: '', // 私立学校
          publicPayment: '', // 公缴
          publicWeal: ''// 公益
        }
      }
    }
  },
  methods: {
    goodsInfo (row) {
      if (row.columnIndex === 2) {
        return 'goodsInfo'// 给第2个td里面添加goodsInfo的类名
      }
    },
    goT0Settle (row) {
      this.selectedT0Entity = row
      this.isShowOpenT0SettleDialog = true
    },
    doOpenT0Settle () {
      const param = {
        agentId: this.selectedT0Entity.fAgentId,
        t0SettlementState: this.selectedT0Entity.t0SettlementState === 0 ? 1 : 0
      }
      t0Settlement(qs.stringify(param)).then(response => {
        if (response.error_code === '0') {
          this.$message({
            showClose: true,
            message: this.selectedT0Entity.t0SettlementState === 0 ? '开通成功' : '关闭成功',
            type: 'success'
          })
          this.isShowOpenT0SettleDialog = false
          this.onSearch()
        } else {
          this.$message({
            showClose: true,
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    getUserInfo () {
      this.roleName = this.$store.getters.roleName
    },
    deleteValid (v) {
      if (v) {
        if (this.table_type === 'sale') {
          this.$refs.addSaleForm.validateField('masterChannelId')
        } else {
          this.$refs.addStaffForm.validateField('masterChannelId')
        }
      }
    },
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_subAg.startTime = value[0]
        this.search_subAg.endTime = value[1]
      } else {
        this.search_subAg.startTime = ''
        this.search_subAg.endTime = ''
      }
    },
    changeVCity (item) {
      this.edit_group_list = []
      // this.editSaleForm.f_group_id = '';
      if (!this.editSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.editSaleForm.f_city_code, 'edit')
    },
    changeCity () {
      this.add_group_list = []
      this.addSaleForm.f_group_id = ''
      if (!this.addSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.addSaleForm.f_city_code, 'add')
    },
    handleClick () {
      this.getList()
    },
    transferType (index, row) {
      this.$confirm('转职成功后将不可修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dynamicTags.splice(this.dynamicTags.indexOf('tag'), 1)
        this.$message({
          type: 'success',
          message: '转职成功!'
        })
      })
    },
    // 显示编辑界面
    handleSale (index, row, scope) {
      this.dialogDisabled = this.$store.getters.roleId !== 3 && row.fAgentParentId !== this.agentId
      this.dialogFormVisible = true
      this.editDialogContent = 'agentInfo'
      console.log(row)
      this.defaultDataParam = this.$options.data().defaultDataParam
      this.dataParam = {}
      this.setDefaultRate()
      this.getRate()
      this.getRow(row.fAgentId)
      this.selectedTemplate = ''
    },
    tableSortChange1 (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_subAg.orderColumn = val.prop
          this.search_subAg.orderType = 1
        } else {
          this.search_subAg.orderColumn = val.prop
          this.search_subAg.orderType = 0
        }
      }
      this.getList()
    },
    closeViewDialog () {
      this.$refs.changeTradeStateform && this.$refs.changeTradeStateform.resetFields()
    },
    closeDialog () {
    },
    showAddSale () {
    },
    handleChange (value) {
      this.getFBankAreaPrvince(value)
    },
    setBankName (value) {
      const obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      this.baseInfo.fBankTypeCode = obj.F_bank_name_code

      // 置空省份、市和分行网点
      this.baseInfo.fBankArea = ''
      this.baseInfo.fBankCity = ''
      this.baseInfo.fBankPoint = ''
    },

    initRouters () {
      // this.$router.push("/saleManager/sales");
      var routes = this.$router.options.routes
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].hidden !== true && routes[i].children && routes[i].children.length) {
          var tempObj = {}
          var module = routes[i]
          var menus = module.children
          tempObj.name = module.name
          tempObj.path = module.path
          tempObj.access = module.path
          tempObj.children = []
          var menuLen = menus.length
          for (var j = 0; j < menuLen; j++) {
            if (menus[j].hidden !== true && menus[j].children && menus[j].children.length) {
              var tempChildObj = {}
              var menu = menus[j]
              var pages = menu.children
              tempChildObj.name = menu.name
              tempChildObj.path = '/' + menu.path
              tempChildObj.access = tempObj.path + '/' + menu.path
              tempChildObj.children = []
              var pagesLen = pages.length
              for (var k = 0; k < pagesLen; k++) {
                if (pages[k].hidden !== true) {
                  var tempPageObj = {}
                  var page = pages[k]
                  tempPageObj.name = page.name
                  tempPageObj.path = '/' + page.path
                  tempPageObj.access = tempObj.path + '/' + menu.path + '/' + page.path
                  tempChildObj.children.push(tempPageObj)
                }
              }
              tempObj.children.push(tempChildObj)
            }
          }
          this.accesss.push(tempObj)
        }
      }
      // var roles = this.$store.state.user.userinfo.f_roles;
      // if (roles.indexOf(6) === -1) {
      //   this.disabledInput = true;
      // }
    },
    toQueryPair (key, value) {
      if (typeof value === 'undefined') {
        return key
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value))
    },
    toQueryString (obj) {
      var ret = []
      var that = this
      for (var key in obj) {
        key = encodeURIComponent(key)
        var values = obj[key]
        if (values && values.constructor === Array) { // 数组
          var queryValues = []
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i]
            queryValues.push(that.toQueryPair(key, value))
          }
          ret = ret.concat(queryValues)
        } else { // 字符串
          ret.push(that.toQueryPair(key, values))
        }
      }
      return ret.join('&')
    },
    /**
       * 点击搜索按钮事件
       */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_subAg.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * 改变页码和当前页时需要拼装的路径方法
       * @param {string} field 参数字段名
       * @param {string} value 参数字段值
       */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      query[field] = value

      this.$router.push({
        path: path,
        query: query
      })
    },
    formatStatus (item) {
      return item.fBlockStatus === 0 ? '正常' : (item.fBlockStatus === 1 ? '冻结' : '注销')
    },
    formatLevel (item) {
      return item.fAgentLevel === 1 ? '一代' : (item.fAgentLevel === 2 ? '二代' : (item.fAgentLevel === 3 ? '三代' : (item.fAgentLevel === 4 ? '四代' : (item.fAgentLevel === 5 ? '五代' : '六代'))))
    },
    formatType (item) {
      return item.fBankAccountType === 1 ? '个人' : '公司'
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      // this.setPath('pageNum', page);
      var totalCount = this.salesNum
      var pageSize = this.paginations.pageSize
      this.search_subAg.pageNo = page
      this.search_subAg.pageSize = pageSize
      this.search_subAg.Count = totalCount
      // this.search_subAg.pageSize = size;
      this.getList()
    },

    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_subAg.pageSize = size
      this.search_subAg.pageNo = pageNo
      this.search_subAg.Count = totalCount
      this.onSearch()
    },
    getGroup (id, type) {
      getSalesmanGroup({
        f_city_code: id
      }).then((data) => {
        if (parseInt(data.code) !== 0) {
        } else {
          if (type === 'search') {
            this.search_group_list = data.data
          } else if (type === 'add') {
            this.add_group_list = data.data
          } else {
            this.edit_group_list = data.data
          }
        }
      })
    },
    /**
       * 需要隐藏信息的输入框获取焦点
       */
    needHideInfoInputFocus (type) {
      if (this.baseInfo[type]) {
        this.baseInfo[type] = ''
        this.baseInfo[`real${type}`] = ''
      }
    },
    // 获取编辑业务员信息
    getRow (id) {
      var data = {
        FAgentId: id
      }
      var that = this
      data = qs.stringify(data)
      subAgentDetail(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else if (parseInt(data.error_code) === 0) {
          console.log('🚀 ~ file: agentInfo.vue ~ line 1611 ~ subAgentDetail ~ data', data)
          var baseInfo = data.baseInfo
          that.isShowD0 = data.baseInfo.t0SettlementState === 1
          that.fRate = data.FRate / 100
          that.pos = data.pos
          that.scan = data.scan
          that.unionpay = data.unionpay
          that.ruleType = data.ruleType

          baseInfo.fAgentPassword = ''
          if (baseInfo.fBankAccount === '' && baseInfo.fBankAccount === '') {
            baseInfo.fBankAccountType = ''
          }

          baseInfo.realfMobile = baseInfo.fMobile
          baseInfo.fMobile = hidePhoneNum(baseInfo.fMobile)
          baseInfo.realfBankAccount = baseInfo.fBankAccount
          baseInfo.fBankAccount = hideRealName(baseInfo.fBankAccount)
          baseInfo.realfIdentityCard = baseInfo.fIdentityCard
          baseInfo.fIdentityCard = hideIdCardNum(baseInfo.fIdentityCard)
          baseInfo.realfBankCardid = baseInfo.fBankCardid
          baseInfo.fBankCardid = hideBankCardNum(baseInfo.fBankCardid)
          baseInfo.realfBankMobile = baseInfo.fBankMobile
          baseInfo.fBankMobile = hidePhoneNum(baseInfo.fBankMobile)

          that.baseInfo = Object.assign({}, that.baseInfo, baseInfo)

          this.setRate()

          // 获取扫码点餐类的字段
          that.scanOrder.t1WeixinIncrementCommission = data.scan.t1WeixinIncrementCommission / 100
          that.scanOrder.t1AlipayIncrementCommission = data.scan.t1AlipayIncrementCommission / 100
          that.scanOrder.t1UnionpayCreditIncrementRate = data.unionpay.t1UnionpayCreditIncrementRate / 100
          that.scanOrder.t1UnionpayDebitIncrementRate = data.unionpay.t1UnionpayDebitIncrementRate / 100
          that.scanOrder.t1UnionpayDebitIncrementMaxFee = data.unionpay.t1UnionpayDebitIncrementMaxFee / 1000000

          that.scanOrder.t1UnionpayGt1000DebitIncrementRate = data.unionpay.t1UnionpayGt1000DebitIncrementRate / 100
          that.scanOrder.t1UnionpayGt1000CreditIncrementRate = data.unionpay.t1UnionpayGt1000CreditIncrementRate / 100

          // 获取日化
          that.rihuaEntity.wxCategoryDebitCommissionD1 = data.scan.wxCategoryDebitCommissionD1 / 100
          that.rihuaEntity.wxCategoryCreditCommissionD1 = data.scan.wxCategoryCreditCommissionD1 / 100
        }
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * 获取用户信息列表方法
       */
    getList () {
      this.saleLoading = true
      var levelName = this.search_subAg.FAgentLevel
      var level;
      (levelName === '一代' ? level = 1 : (levelName === '二代' ? level = 2 : (levelName === '三代' ? level = 3
        : (levelName === '四代' ? level = 4 : (levelName === '五代' ? level = 5 : (levelName === '六代' ? level = 6 : level = ''))))))
      this.search_subAg.FAgentLevel = level
      var data = this.formatSearch(this.search_subAg)
      this.search_subAg.FAgentLevel = levelName
      data = qs.stringify(data)

      subAgentList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          this.saleLoading = false
          this.paginations.total = data.totalCount
          this.subAg_list = data.list
          this.subAg_list.forEach(item => {
            item.t0SettlementStateStr = item.t0SettlementState === 0 ? '否' : '是'
          })
          this.salesNum = data.totalCount
        }
      })
    },
    formatTotalAmount (item) {
      return this.fmoney(item.f_merchant_total_amount / 100, 2)
    },
    formatTotalIncome (item) {
      return this.fmoney(item.f_total_income / 100, 2)
    },
    fmoney (s, n) {
      if (n) {
        n = n > 0 && n <= 20 ? n : 2
      } else {
        n = 0
      }
      // eslint-disable-next-line no-useless-escape
      s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
      var l = s.split('.')[0].split('').reverse()
      var r = s.split('.')[1]
      var t = ''
      for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
      }
      if (r) {
        return t.split('').reverse().join('') + '.' + r
      } else {
        return t.split('').reverse().join('')
      }
    },

    changeProvince () {
      this.citys = []
      this.cityForm.f_code = ''
      if (this.cityForm.f_parent_code === '') {
        return false
      }
      var query = this.cityForm.f_parent_code
      let obj = {}
      obj = this.proCity_list.find((item) => {
        return item.f_code === query
      })
      this.citys = obj.f_city_list
    },
    /**
       * 获取城市列表方法
       */
    getCityList () {
      getSalesmanCitys({}).then((data) => {
        if (parseInt(data.code) !== 0) {
        } else {
          this.city_list = data.data
        }
      })
    },
    // 获取select省市
    getProcityList () {
      getSalesmanProcity({}).then((data) => {
        if (parseInt(data.code) !== 0) {
        } else {
          this.proCity_list = data.data
        }
      })
    },
    // 获取银行列表
    getBank () {
      var that = this
      // eslint-disable-next-line no-undef
      this.$jquery.ajax({
        type: 'POST',
        asyn: false,
        url: that.domain + 'leposweb/home/getbanknamecode.do',
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.bank_list = eval(json.list)
        }
      })
    },
    // 获取省列表
    getPro () {
      var that = this
      // eslint-disable-next-line no-undef
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/home/getbankareacode.do',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.pro_list = eval(json.list)
        }
      })
    },
    // 获取市列表
    getCity () {
      var that = this
      var bankAreaCode = this.baseInfo.FBankAreaCode
      // eslint-disable-next-line no-undef
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: { bankAreaCode: bankAreaCode },
        url: that.domain + 'leposweb/home/getbankcitycode.do?',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.city_list = eval(json.list)
        }
      })
    },
    // 设置省
    setBankPro (value) {
      if (value) {
        let obj = {}
        obj = this.pro_list.find((item) => {
          return item.F_bank_area === value
        })
        this.baseInfo.FBankArea = value
        this.baseInfo.FBankAreaCode = obj.F_bank_area_code
        if (this.baseInfo.FBankAreaCode) {
          this.getCity()
        }
      }
      // 置空市和分行网点
      this.baseInfo.fBankCity = ''
      this.baseInfo.fBankPoint = ''
    },
    // 设置市
    setBankCity (value) {
      if (value) {
        let obj = {}
        obj = this.city_list.find((item) => {
          return item.F_bank_city === value
        })
        this.baseInfo.FBankCityCode = obj.F_bank_city_code
        if (this.baseInfo.FBankCityCode) {
          this.getBranchList()
        }
      }
      // 置空分行网点
      this.baseInfo.fBankPoint = ''
    },
    // 设置网点
    setBranch (value) {
      if (value) {
        let obj = {}
        obj = this.branch_list.find((item) => {
          return item.F_branch_name === value
        })
        this.baseInfo.fBankPointCode = obj.F_branch_no
      }
    },
    getBranchList () {
      var that = this
      var bankNo = this.baseInfo.fBankTypeCode
      var cityNo = this.baseInfo.FBankCityCode
      that.seloading = true
      this.$jquery.ajax({
        type: 'POST',
        url: that.domain + 'leposweb/home/getbankbranch2.do',
        data: { bankNo: bankNo, cityNo: cityNo },
        dataType: 'jsonp',
        success: function (json) {
          if (!json.list) {
            that.$message({
              message: json.errorMsg,
              type: 'error'
            })
          } else {
            // eslint-disable-next-line no-eval
            json = eval(json.list)
            if (json.length > 0) {
              that.branch_list = json
              that.seloading = false
            }
          }
        }
      })
    },
    setDefaultRate () {
      this.$jquery('.t1DebitCommission').val(this.defaultDataParam.t1Debit)
      this.$jquery('.t1DebitMaxFee').val(this.defaultDataParam.t1DebitMax)
      this.$jquery('.t1CreditCommission').val(this.defaultDataParam.t1Credit)
      this.$jquery('.t1OverSeasCommission').val(this.defaultDataParam.t1OverSeas)
      this.$jquery('.t1WeixinCommission').val(this.defaultDataParam.t1weixin)
      this.$jquery('.t1AlipayCommission').val(this.defaultDataParam.t1Alipay)
      this.$jquery('.t0WeixinCommission').val(this.defaultDataParam.t0weixin)
      this.$jquery('.t0AlipayCommission').val(this.defaultDataParam.t0Alipay)
      this.$jquery('.posLowerDivideCent').val(this.defaultDataParam.posLower)

      this.$jquery('.t0DebitCommission').val(this.defaultDataParam.t0Debit)
      this.$jquery('.t0CreditCommission').val(this.defaultDataParam.t0Credit)
      this.$jquery('.t0OverSeasCommission').val(this.defaultDataParam.t0OverSeas)
      this.$jquery('.t0FixFee').val(this.defaultDataParam.t0FixFee)
      this.$jquery('.t0WeixinCommission').val(this.defaultDataParam.t0weixin)
      this.$jquery('.t0AlipayCommission').val(this.defaultDataParam.t0Alipay)
      this.$jquery('.scanLowerDivideCent').val(this.defaultDataParam.scanLower)
      // this.$jquery(".lowerDivideCent").val(lower);

      this.$jquery('.fT1DebitCommissionBymillion').val(this.defaultDataParam.t1UnionDebit)
      this.$jquery('.fT1CreditCommissionBymillion').val(this.defaultDataParam.t1UnionCredit)
      this.$jquery('.fT1OverseasCommissionBymillion').val(this.defaultDataParam.t1UnionOverseas)
      this.$jquery('.fT0DebitCommissionBymillion').val(this.defaultDataParam.t0UnionDebit)
      this.$jquery('.fT0CreditCommissionBymillion').val(this.defaultDataParam.t0UnionCredit)
      this.$jquery('.fT0OverseasCommissionBymillion').val(this.defaultDataParam.t0UnionOverseas)
      this.$jquery('.unionLowerDivideCent').val(this.defaultDataParam.unionLower)
      this.$jquery('.fT1UnionpayDebitMaxCharge').val(this.defaultDataParam.t1UnionpayDebitMaxCharge)

      this.$jquery('.fT1BelowDebitCommissionBymillion').val(this.defaultDataParam.t1BelowUnionDebitRate)
      this.$jquery('.fT0BelowDebitCommissionBymillion').val(this.defaultDataParam.t0BelowUnionDebitRate)
      this.$jquery('.fT1BelowCreditCommissionBymillion').val(this.defaultDataParam.t1BelowUnionCreditRate)
      this.$jquery('.fT0BelowCreditCommissionBymillion').val(this.defaultDataParam.t0BelowUnionCreditRate)

      this.$jquery('.fT1BelowOverseasCommissionBymillion').val(this.defaultDataParam.t1BelowUnionOverseasRate)
      this.$jquery('.fT0BelowOverseasCommissionBymillion').val(this.defaultDataParam.t0BelowUnionOverseasRate)
    },
    /**
       * @deprecated 获取默认费率方法
       */
    getRate () {
      var that = this
      var data = ''
      data = qs.stringify(data)
      getAgFee(data).then(function (data) {
        if (parseInt(data.error_code) !== 0) {
          that.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          that.pos = data.pos
          that.scan = data.scan
          that.unionpay = data.unionpay
          that.ruleType = data.ruleType
          var fRate = data.FRate / 100

          if (that.ruleType === 0) {
          } else {
            that.defaultDataParam.fRate = fRate
            const pos = data.pos
            const scan = data.scan
            const unionpay = data.unionpay
            that.defaultDataParam.t1DebitCommission = (pos.t1DebitCommission) / 100
            that.defaultDataParam.t0DebitCommission = (pos.t0DebitCommission) / 100
            that.defaultDataParam.t1CreditCommission = (pos.t1CreditCommission) / 100
            that.defaultDataParam.t0CreditCommission = (pos.t0CreditCommission) / 100
            that.defaultDataParam.t1OverSeasCommission = (pos.t1OverSeasCommission) / 100
            that.defaultDataParam.t0OverSeasCommission = (pos.t0OverSeasCommission) / 100
            that.defaultDataParam.t1DebitMaxFee = (pos.t1DebitMaxFee) / 1000000
            that.defaultDataParam.t0FixFee = (pos.t0FixFee) / 1000000
            that.defaultDataParam.t1WeixinCommission = (scan.t1WeixinCommission) / 100
            that.defaultDataParam.t1AlipayCommission = (scan.t1AlipayCommission) / 100
            that.defaultDataParam.t0WeixinCommission = (scan.t0WeixinCommission) / 100
            that.defaultDataParam.t0AlipayCommission = (scan.t0AlipayCommission) / 100
            that.defaultDataParam.fT1DebitCommissionBymillion = (unionpay.fT1DebitCommissionBymillion) / 100
            that.defaultDataParam.fT1CreditCommissionBymillion = (unionpay.fT1CreditCommissionBymillion) / 100
            that.defaultDataParam.fT1BelowDebitCommissionBymillion = unionpay.fT1DebitCommissionBymillionLevel2 / 100
            that.defaultDataParam.fT1BelowCreditCommissionBymillion = unionpay.fT1CreditCommissionBymillionLevel2 / 100
            that.defaultDataParam.fT0DebitCommissionBymillion = (unionpay.fT0DebitCommissionBymillion) / 100
            that.defaultDataParam.fT0CreditCommissionBymillion = (unionpay.fT0CreditCommissionBymillion) / 100
            that.defaultDataParam.fT0BelowDebitCommissionBymillion = unionpay.fT0DebitCommissionBymillionLevel2 / 100
            that.defaultDataParam.fT0BelowCreditCommissionBymillion = unionpay.fT0CreditCommissionBymillionLevel2 / 100
            that.defaultDataParam.fT1UnionpayDebitMaxCharge = (unionpay.fT1DebitMaxFeeBymillion) / 1000000
            if (scan.extraFeeRate) {
              const extraFeeRate = JSON.parse(scan.extraFeeRate)
              for (const item in that.defaultDataParam.extraFeeRate.alipay) {
                if (typeof (extraFeeRate.alipay[item]) === 'number') {
                  that.defaultDataParam.extraFeeRate.alipay[item] = (extraFeeRate.alipay[item]) / 100
                } else {
                  that.defaultDataParam.extraFeeRate.alipay[item] = ''
                }
              }
              for (const item in that.defaultDataParam.extraFeeRate.wechat) {
                if (typeof (extraFeeRate.wechat[item]) === 'number') {
                  that.defaultDataParam.extraFeeRate.wechat[item] = (extraFeeRate.wechat[item]) / 100
                } else {
                  that.defaultDataParam.extraFeeRate.wechat[item] = ''
                }
              }
            }
          }
        }
        // 这里做ajax请求
      })
    },
    setRate () {
      var that = this
      console.log()
      if (that.ruleType === 0) {
        // var ruleType = that.ruleType
        this.$jquery('.FLowerDivideCent').val(that.baseInfo.fLowerDivideCent)
      } else {
        console.log('🚀 ~ file: agentInfo.vue ~ line 2139 ~ setRate ~ that.scan', that.scan)
        var fRate = that.fRate
        var t1Debit = (that.pos.t1DebitCommission) / 100
        var t1DebitMax = (that.pos.t1DebitMaxFee) / 1000000
        var t1Credit = (that.pos.t1CreditCommission) / 100
        var t1OverSeas = (that.pos.t1OverSeasCommission) / 100
        var t1weixin = (that.scan.t1WeixinCommission) / 100
        var t1Alipay = (that.scan.t1AlipayCommission) / 100

        var t0Debit = (that.pos.t0DebitCommission) / 100
        var t0Credit = (that.pos.t0CreditCommission) / 100
        var t0OverSeas = (that.pos.t0OverSeasCommission) / 100
        var t0FixFee = (that.pos.t0FixFee) / 1000000
        var t0weixin = (that.scan.t0WeixinCommission) / 100
        var t0Alipay = (that.scan.t0AlipayCommission) / 100

        var t1UnionDebit = (that.unionpay.fT1DebitCommissionBymillion) / 100
        var t0UnionDebit = (that.unionpay.fT0DebitCommissionBymillion) / 100
        var t1UnionCredit = (that.unionpay.fT1CreditCommissionBymillion) / 100
        var t0UnionCredit = (that.unionpay.fT0CreditCommissionBymillion) / 100
        var t1UnionOverseas = (that.unionpay.fT1OverseasCommissionBymillion) / 100
        var t0UnionOverseas = (that.unionpay.fT0OverseasCommissionBymillion) / 100

        var t1UnionpayDebitMaxCharge = (that.unionpay.fT1DebitMaxFeeBymillion) / 1000000

        var t1BelowUnionCreditRate = that.unionpay.fT1CreditCommissionBymillionLevel2 / 100
        var t0BelowUnionCreditRate = that.unionpay.fT0CreditCommissionBymillionLevel2 / 100
        var t1BelowUnionDebitRate = that.unionpay.fT1DebitCommissionBymillionLevel2 / 100
        var t0BelowUnionDebitRate = that.unionpay.fT0DebitCommissionBymillionLevel2 / 100
        var t1BelowUnionOverseasRate = that.rounding(Number(t1UnionOverseas * 1))
        var t0BelowUnionOverseasRate = that.rounding(Number(t0UnionOverseas * 1))

        var scanLower = that.scan.lowerDivideCent
        var posLower = that.pos.lowerDivideCent
        var unionLower = that.unionpay.fLowerDivideCent
        console.log('🚀 ~ file: agentInfo.vue ~ line 2113 ~ setRate ~ t0weixin', t0weixin)
        this.$jquery('.t1DebitCommission').val(t1Debit)
        this.$jquery('.t1DebitMaxFee').val(t1DebitMax)
        this.$jquery('.t1CreditCommission').val(t1Credit)
        this.$jquery('.t1OverSeasCommission').val(t1OverSeas)
        this.$jquery('.t1WeixinCommission').val(t1weixin)
        this.$jquery('.t1AlipayCommission').val(t1Alipay)
        this.$jquery('.t0WeixinCommission').val(t0weixin)
        this.$jquery('.t0AlipayCommission').val(t0Alipay)
        this.$jquery('.t0DebitCommission').val(t0Debit)
        this.$jquery('.t0CreditCommission').val(t0Credit)
        this.$jquery('.t0OverSeasCommission').val(t0OverSeas)
        this.$jquery('.t0FixFee').val(t0FixFee)
        this.$jquery('.scanLowerDivideCent').val(scanLower)
        this.$jquery('.posLowerDivideCent').val(posLower)
        this.$jquery('.unionLowerDivideCent').val(unionLower)

        this.$jquery('.fT1DebitCommissionBymillion').val(t1UnionDebit)
        this.$jquery('.fT1CreditCommissionBymillion').val(t1UnionCredit)
        this.$jquery('.fT1OverseasCommissionBymillion').val(t1UnionOverseas)
        this.$jquery('.fT0DebitCommissionBymillion').val(t0UnionDebit)
        this.$jquery('.fT0CreditCommissionBymillion').val(t0UnionCredit)
        this.$jquery('.fT0OverseasCommissionBymillion').val(t0UnionOverseas)
        this.$jquery('.unionLowerDivideCent').val(unionLower)
        this.$jquery('.fT1UnionpayDebitMaxCharge').val(t1UnionpayDebitMaxCharge)

        this.$jquery('.fT1BelowDebitCommissionBymillion').val(t1BelowUnionDebitRate)
        this.$jquery('.fT0BelowDebitCommissionBymillion').val(t0BelowUnionDebitRate)
        this.$jquery('.fT1BelowCreditCommissionBymillion').val(t1BelowUnionCreditRate)
        this.$jquery('.fT0BelowCreditCommissionBymillion').val(t0BelowUnionCreditRate)

        this.$jquery('.fT1BelowOverseasCommissionBymillion').val(t1BelowUnionOverseasRate)
        this.$jquery('.fT0BelowOverseasCommissionBymillion').val(t0BelowUnionOverseasRate)

        that.dataParam.scanLower = scanLower
        that.dataParam.posLower = posLower
        that.dataParam.unionLower = unionLower

        that.dataParam.t1Debit = t1Debit
        that.dataParam.t1DebitMax = t1DebitMax
        that.dataParam.t1Credit = t1Credit
        that.dataParam.t1OverSeas = t1OverSeas
        that.dataParam.t1weixin = t1weixin
        that.dataParam.t1Alipay = t1Alipay
        that.dataParam.t0Debit = t0Debit
        that.dataParam.t0Credit = t0Credit
        that.dataParam.t0OverSeas = t0OverSeas
        that.dataParam.t0FixFee = t0FixFee
        that.dataParam.t0weixin = t0weixin
        that.dataParam.t0Alipay = t0Alipay
        that.dataParam.t1UnionDebit = t1UnionDebit
        that.dataParam.t0UnionDebit = t0UnionDebit
        that.dataParam.t1UnionCredit = t1UnionCredit
        that.dataParam.t0UnionCredit = t0UnionCredit
        that.dataParam.t1UnionOverseas = t1UnionOverseas
        that.dataParam.t0UnionOverseas = t0UnionOverseas
        that.dataParam.t1UnionpayDebitMaxCharge = t1UnionpayDebitMaxCharge
        that.dataParam.t1BelowUnionCreditRate = t1BelowUnionCreditRate
        that.dataParam.t0BelowUnionCreditRate = t0BelowUnionCreditRate
        that.dataParam.t1BelowUnionDebitRate = t1BelowUnionDebitRate
        that.dataParam.t0BelowUnionDebitRate = t0BelowUnionDebitRate
        that.dataParam.t1BelowUnionOverseasRate = t1BelowUnionOverseasRate
        that.dataParam.t0BelowUnionOverseasRate = t0BelowUnionOverseasRate
        that.dataParam.fRate = fRate
        // 待测试
        if (that.scan.extraFeeRate) {
          that.extraFeeRate = that.$options.data().extraFeeRate
          const extraFeeRate = JSON.parse(that.scan.extraFeeRate)
          console.log(extraFeeRate)
          for (const item in that.extraFeeRate.alipay) {
            if (typeof (extraFeeRate.alipay[item]) === 'number') {
              this.$jquery('.' + 'alipay_' + item).val((extraFeeRate.alipay[item]) / 100)
            } else {
              this.$jquery('.' + 'alipay_' + item).val('')
            }
          }
          for (const item in that.extraFeeRate.wechat) {
            if (typeof (extraFeeRate.wechat[item]) === 'number') {
              this.$jquery('.' + 'wechat_' + item).val((extraFeeRate.wechat[item]) / 100)
            } else {
              this.$jquery('.' + 'wechat_' + item).val('')
            }
          }
        }
      }
    },

    // 费率失去光标
    onRateBlur (value, extraValue) {
      console.log('🚀 ~ file: rateForm.vue ~ line 1025 ~ onRateBlur ~ value', value)
      console.log('🚀 ~ file: rateForm.vue ~ line 1026 ~ onRateBlur ~ defaultDataParam', this.defaultDataParam)
      console.log('🚀 ~ file: rateForm.vue ~ line 1026 ~ onRateBlur ~ defaultRate', this.defaultDataParam)
      let message = ''
      let numberValue, defaultValue
      if (extraValue) {
        const extraText = extraValue.split('.')
        numberValue = Number(this.$jquery('.' + extraText[0] + '_' + extraText[1]).val())// 格式转换
        defaultValue = this.defaultDataParam.extraFeeRate[extraText[0]][extraText[1]]
        // return true; // 多通道费率先不校验
      } else {
        numberValue = Number(this.$jquery('.' + value).val())// 格式转换
        defaultValue = this.defaultDataParam[value]// 默认值
      }

      let result = true// 校验结果
      let type = ''// 校验类型
      // 如果费率为空或小于默认值，校验不通过
      if (isNaN(numberValue) || numberValue < defaultValue) {
        result = false
      }
      // 判断类型，根据不同类型进行不同校验
      if (value.toLowerCase().indexOf('t1') >= 0) {
        type = 'T1'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('overseas') >= 0) {
        type = 'T1Overseas'
      }
      if (value.toLowerCase().indexOf('t0') >= 0) {
        type = 'T0'
      }
      if (value.toLowerCase().indexOf('unionpay') >= 0) {
        type = 'UnionRate'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('fee') >= 0) {
        type = 'T1Fee'
      }
      if (value.toLowerCase().indexOf('t0') >= 0 && value.toLowerCase().indexOf('fee') >= 0) {
        type = 'T0Fee'
      }
      if (value.toLowerCase().indexOf('lower') >= 0) {
        type = 'lower'
      }
      // 不同类型的报错信息不一致
      switch (type) {
        case 'T1': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T1Overseas': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T0': {
          message = `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T0Fee': {
          message = '单笔手续费不能为空、小于默认手续费 或超过20'
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'T1Fee': {
          message = `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'lower': {
          message = '额外收取下级分成比例不能是小数，小于0或者大于100'
          if (numberValue < 0 || numberValue > 100 || Number(numberValue) % 1 !== 0) {
            result = false
          }
          break
        }
        default: {
          message = `当前费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
        }
      }

      if (!result) {
        this.$message({
          showClose: true,
          message: message,
          type: 'warning'
        })
        if (extraValue) {
          const extraText = extraValue.split('.')
          this.$jquery('.' + extraText[0] + '_' + extraText[1]).val(defaultValue)
        } else {
          this.$jquery('.' + value).val(defaultValue)
        }
        return false
      }
      return true
    },
    rounding (n1) {
      return n1.toFixed(2)
    },
    // 编辑
    editSubmit () {
      var that = this
      var pw = that.baseInfo.fAgentPassword
      that.editForm.FAgentPassword = that.baseInfo.fAgentPassword
      that.editForm.FAgentAccount = that.baseInfo.fAgentAccount
      that.editForm.FName = that.baseInfo.fName
      that.editForm.FTitle = that.baseInfo.fTitle
      that.editForm.fBankAccount = that.baseInfo.fBankAccount
      that.editForm.FMobile = that.baseInfo.realfMobile || that.baseInfo.fMobile
      that.editForm.insertFlag = 0 // 修改代理商信息 传0

      // 费率
      var t1DebitCommission = Math.round((this.$jquery('.t1DebitCommission').val()) * 100)
      var t1DebitMaxFee = Math.round((this.$jquery('.t1DebitMaxFee').val()) * 1000000)
      var t0DebitCommission = Math.round((this.$jquery('.t0DebitCommission').val()) * 100)
      var t1CreditCommission = Math.round((this.$jquery('.t1CreditCommission').val()) * 100)
      var t0CreditCommission = Math.round((this.$jquery('.t0CreditCommission').val()) * 100)

      var t1OverSeasCommission = Math.round((this.$jquery('.t1OverSeasCommission').val()) * 100)
      var t0OverSeasCommission = Math.round((this.$jquery('.t0OverSeasCommission').val()) * 100)
      var t0FixFee = Math.round((this.$jquery('.t0FixFee').val()) * 1000000)
      var posLowerDivideCent = Math.round(this.$jquery('.posLowerDivideCent').val())

      var t1WeixinCommission = Math.round((this.$jquery('.t1WeixinCommission').val()) * 100)
      var t0WeixinCommission = Math.round((this.$jquery('.t0WeixinCommission').val()) * 100)
      var t1AlipayCommission = Math.round((this.$jquery('.t1AlipayCommission').val()) * 100)

      var t0AlipayCommission = Math.round((this.$jquery('.t0AlipayCommission').val()) * 100)
      var scanLowerDivideCent = Math.round(this.$jquery('.scanLowerDivideCent').val())

      var t1UnionpayDebitRate = Math.round((this.$jquery('.fT1DebitCommissionBymillion').val()) * 100)
      var t1UnionpayCreditRate = Math.round((this.$jquery('.fT1CreditCommissionBymillion').val()) * 100)

      var t0UnionpayDebitRate = Math.round((this.$jquery('.fT0DebitCommissionBymillion').val()) * 100)

      var t0UnionpayCreditRate = Math.round((this.$jquery('.fT0CreditCommissionBymillion').val()) * 100)

      var t0UnionpayCreditRateLevel2 = Math.round((this.$jquery('.fT0BelowCreditCommissionBymillion').val()) * 100)
      var t0UnionpayDebitRateLevel2 = Math.round((this.$jquery('.fT0BelowDebitCommissionBymillion').val()) * 100)
      var t1UnionpayBelowDebitRate = Math.round((this.$jquery('.fT1BelowDebitCommissionBymillion').val()) * 100)
      var t1UnionpayBelowCreditRate = Math.round((this.$jquery('.fT1BelowCreditCommissionBymillion').val()) * 100)
      var unionLowerDivideCent = Math.round(this.$jquery('.unionLowerDivideCent').val())

      var t1UnionpayDebitMaxCharge = Math.round(this.$jquery('.fT1UnionpayDebitMaxCharge').val() * 1000000)
      for (const key in that.extraFeeRate.alipay) {
        that.extraFeeRate.alipay[key] = this.$jquery('.' + 'alipay_' + key).val() !== '' ? Math.round((this.$jquery('.' + 'alipay_' + key).val()) * 100) : ''
      }
      for (const key in that.extraFeeRate.wechat) {
        that.extraFeeRate.wechat[key] = this.$jquery('.' + 'wechat_' + key).val() !== '' ? Math.round((this.$jquery('.' + 'wechat_' + key).val()) * 100) : ''
      }
      console.log(that.extraFeeRate)
      that.editForm.t1DebitCommission = t1DebitCommission
      that.editForm.t1DebitMaxFee = t1DebitMaxFee
      that.editForm.t0DebitCommission = t0DebitCommission
      that.editForm.t1CreditCommission = t1CreditCommission
      that.editForm.t0CreditCommission = t0CreditCommission
      that.editForm.t1OverSeasCommission = t1OverSeasCommission
      that.editForm.t0OverSeasCommission = t0OverSeasCommission
      that.editForm.t0FixFee = t0FixFee
      that.editForm.posLowerDivideCent = posLowerDivideCent
      that.editForm.t1WeixinCommission = t1WeixinCommission
      that.editForm.t0WeixinCommission = t0WeixinCommission
      that.editForm.t1AlipayCommission = t1AlipayCommission
      that.editForm.t0AlipayCommission = t0AlipayCommission
      that.editForm.scanLowerDivideCent = scanLowerDivideCent

      that.editForm.t0UnionpayCreditRateLevel2 = t0UnionpayCreditRateLevel2
      that.editForm.t0UnionpayDebitRateLevel2 = t0UnionpayDebitRateLevel2
      that.editForm.t1UnionpayDebitRate = t1UnionpayDebitRate
      that.editForm.t1UnionpayCreditRate = t1UnionpayCreditRate
      that.editForm.t1UnionpayOverseasRate = 260
      that.editForm.t0UnionpayDebitRate = t0UnionpayDebitRate
      that.editForm.t0UnionpayCreditRate = t0UnionpayCreditRate
      that.editForm.t0UnionpayOverseasRate = 300
      that.editForm.t1UnionpayDebitRateLevel2 = t1UnionpayBelowDebitRate
      that.editForm.t1UnionpayCreditRateLevel2 = t1UnionpayBelowCreditRate
      that.editForm.unionLowerDivideCent = unionLowerDivideCent
      that.editForm.t1UnionpayDebitMaxCharge = t1UnionpayDebitMaxCharge

      that.editForm.FLowerDivideCent = that.baseInfo.fLowerDivideCent

      that.editForm.FBankAccountType = that.baseInfo.fBankAccountType

      that.editForm.FBankAccount = that.baseInfo.realfBankAccount || that.baseInfo.fBankAccount
      that.editForm.FIdentityCard = that.baseInfo.realfIdentityCard || that.baseInfo.fIdentityCard
      that.editForm.FBankCardid = that.baseInfo.realfBankCardid || that.baseInfo.fBankCardid
      that.editForm.FBankType = that.baseInfo.fBankType
      that.editForm.FBankArea = that.baseInfo.fBankArea
      that.editForm.FBankCity = that.baseInfo.fBankCity
      that.editForm.FBankAreaCode = that.baseInfo.FBankAreaCode
      that.editForm.FBankCityCode = that.baseInfo.FBankCityCode
      that.editForm.FBankMobile = that.baseInfo.realfBankMobile || that.baseInfo.fBankMobile
      that.editForm.FBankPoint = that.baseInfo.fBankPoint
      that.editForm.FAgentId = that.baseInfo.fAgentId

      that.editForm.FBankTypeCode = that.baseInfo.fBankTypeCode
      that.editForm.FBankPointCode = that.baseInfo.fBankPointCode

      // 新增扫码点餐类字段
      that.editForm.t1WeixinIncrementCommission = Math.round(that.scanOrder.t1WeixinIncrementCommission * 100)
      that.editForm.t1AlipayIncrementCommission = Math.round(that.scanOrder.t1AlipayIncrementCommission * 100)
      that.editForm.t1UnionpayCreditIncrementRate = Math.round(that.scanOrder.t1UnionpayCreditIncrementRate * 100)
      that.editForm.t1UnionpayDebitIncrementRate = Math.round(that.scanOrder.t1UnionpayDebitIncrementRate * 100)
      that.editForm.t1UnionpayDebitIncrementMaxFee = Math.round(that.scanOrder.t1UnionpayDebitIncrementMaxFee * 1000000)

      that.editForm.t1UnionpayGt1000DebitIncrementRate = Math.round(that.scanOrder.t1UnionpayGt1000DebitIncrementRate * 100)
      that.editForm.t1UnionpayGt1000CreditIncrementRate = Math.round(that.scanOrder.t1UnionpayGt1000CreditIncrementRate * 100)

      // 新增日化
      that.editForm.wxCategoryDebitCommissionD1 = Math.round(that.rihuaEntity.wxCategoryDebitCommissionD1 * 100)
      that.editForm.wxCategoryCreditCommissionD1 = Math.round(that.rihuaEntity.wxCategoryCreditCommissionD1 * 100)

      Object.keys(that.editForm).forEach(item => {
        if (this.isEmpty(that.editForm[item])) {
          delete that.editForm[item]
        }
        if (item === 't0WeixinCommission' || item === 't0AlipayCommission') {
          if (isNaN(that.editForm[item])) {
            delete that.editForm[item]
          }
        }
      })
      that.editForm.extraFeeRate = JSON.stringify(that.extraFeeRate)
      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.addLoading = true
        let para = Object.assign({}, that.editForm)
        console.log('🚀 ~ file: agentInfo.vue ~ line 2536 ~ that.$confirm ~ that.editForm', that.editForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw) {
          para.FAgentPassword = md5(pw)
        }
        para = qs.stringify(para)
        addSubAgent(para).then(data => {
          that.addLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            that.dialogFormVisible = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    // 判空
    isEmpty (val) {
      if (typeof val === 'undefined' || val === null || val === '') {
        return true
      } else {
        return false
      }
    },
    getAgentLevel () {
      this.agentId = this.$store.getters.userId
      var con = JSON.parse(localStorage.levelConst)
      var compare = function (obj1, obj2) {
        var val1 = obj1.key
        var val2 = obj2.key
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
      this.agent_level_list = con.sort(compare)
    },

    setAgentLevel (item) {
      this.search_subAg.FAgentLevel = item
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
       * 编辑界面代理商信息按钮点击
       */
    showAgentInfo () {
      this.editDialogContent = 'agentInfo'
    },
    /**
       * 编辑界面状态控制按钮点击
       */
    stateControl () {
      this.editDialogContent = 'stateControl'
    },
    /**
       * 状态控制确定点击
       */
    handleStateControlClick () {
      console.log('状态控制确定点击')
      this.$refs.changeTradeStateform.validate(valid => {
        if (valid) {
          this.$confirm('对同一代理商的操作一天仅限一次', '是否确认提交?', {
            type: 'warning'
          }).then(() => {
            this.modifyMerchantTradeStatus()
          })
        } else {
          console.log('error submit!!')
          this.$message({
            message: '提交信息有误，请完善后重新提交',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
       * 一代代理商修改商户交易权限
       */
    modifyMerchantTradeStatus () {
      return new Promise((resolve, reject) => {
        this.addLoading = true
        const operator = this.$store.getters.userId
        const params = qs.stringify({
          operator: operator,
          agentId: this.baseInfo.fAgentId,
          operateType: this.changeTradeStateInfo.operateType,
          reason: this.changeTradeStateInfo.changeReason
        })
        console.log(params)
        modifyAgentApplicationStatus(params).then(response => {
          console.log('modifyAgentApplicationStatus response:', response)
          this.addLoading = false
          if (response.error_code === '200') {
            this.$message({
              showClose: true,
              message: response.error_msg,
              type: 'success'
            })
            this.dialogFormVisible = false
            resolve()
          } else {
            this.$message({
              showClose: true,
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    /**
       * 获取模板下拉列表
       */
    getTemplateList () {
      const params = qs.stringify({
        type: 1
      })
      console.log(params)
      getTemplateList(params).then(response => {
        console.log('getTemplateList response:', response)
        if (response.error_code === '0') {
          this.rateTemplateList = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 根据id获取模板信息
       */
    getTemplate (id) {
      const params = qs.stringify({
        id: id
      })
      console.log(params)
      getTemplate(params).then(response => {
        console.log('getTemplate response:', response)
        if (response.error_code === '0') {
          this.setTemplateRate({
            fRate: response.fRate,
            ...response.data
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 费率模板选择change
       */
    rateTemplateSelectChange (templateId) {
      if (templateId >= 0) {
        this.getTemplate(templateId)
      } else {
        this.setTemplateRate()
      }
    },
    /**
       * 展示费率模板
       */
    setTemplateRate (rateInfo) {
      if (rateInfo) {
        // const fRate = rateInfo.fRate / 100
        if (this.ruleType === 0) {
          this.baseInfo.fLowerDivideCent = rateInfo.fLowerDivideCent / 10000
        } else {
          const t1Debit = (rateInfo.fT1DebitRate) / 10000
          const t1DebitMax = (rateInfo.fT1DebitFeeMax) / 1000000
          const t1Credit = (rateInfo.fT1CreditRate) / 10000
          const t1OverSeas = (rateInfo.fT1OverSeasRate) / 10000
          const t1weixin = (rateInfo.fWxT1Rate) / 10000
          const t1Alipay = (rateInfo.fAliT1Rate) / 10000

          const t0Debit = (rateInfo.fT0DebitRate) / 10000
          const t0Credit = (rateInfo.fT0CreditRate) / 10000
          const t0OverSeas = (rateInfo.fT0OverSeasRate) / 10000
          const t0FixFee = (rateInfo.fT0FixedFee) / 1000000
          const t0weixin = (rateInfo.fWxT0Rate) / 10000
          const t0Alipay = (rateInfo.fAliT0Rate) / 10000

          const t1UnionDebit = (rateInfo.fT1UnionpayDebitRate) / 10000
          const t1UnionCredit = (rateInfo.fT1UnionpayCreditRate) / 10000

          const t0UnionDebit = (rateInfo.fT0UnionpayDebitRate) / 10000
          const t0UnionCredit = (rateInfo.fT0UnionpayCreditRate) / 10000

          const t1UnionpayDebitMaxCharge = rateInfo.fT1UnionpayDebitMaxCharge / 1000000

          const t1BelowUnionCreditRate = rateInfo.fT1UnionpayCreditRateLv2 / 10000
          const t0BelowUnionCreditRate = rateInfo.fT0UnionpayCreditRateLv2 / 10000
          const t1BelowUnionDebitRate = rateInfo.fT1UnionpayDebitRateLv2 / 10000
          const t0BelowUnionDebitRate = rateInfo.fT0UnionpayDebitRateLv2 / 10000

          const posLower = rateInfo.fPosLowerDivideCent / 10000
          const scanLower = rateInfo.fScanLowerDivideCent / 10000
          const unionLower = rateInfo.fUnionLowerDivideCent / 10000

          this.$jquery('.t1DebitCommission').val(t1Debit)
          this.$jquery('.t1DebitMaxFee').val(t1DebitMax)
          this.$jquery('.t1CreditCommission').val(t1Credit)
          this.$jquery('.t1OverSeasCommission').val(t1OverSeas)
          this.$jquery('.t1WeixinCommission').val(t1weixin)
          this.$jquery('.t1AlipayCommission').val(t1Alipay)
          this.$jquery('.t0WeixinCommission').val(t1weixin)
          this.$jquery('.t0AlipayCommission').val(t1Alipay)
          this.$jquery('.posLowerDivideCent').val(posLower)

          this.$jquery('.t0DebitCommission').val(t0Debit)
          this.$jquery('.t0CreditCommission').val(t0Credit)
          this.$jquery('.t0OverSeasCommission').val(t0OverSeas)
          this.$jquery('.t0FixFee').val(t0FixFee)
          this.$jquery('.t0WeixinCommission').val(t0weixin)
          this.$jquery('.t0AlipayCommission').val(t0Alipay)
          this.$jquery('.scanLowerDivideCent').val(scanLower)

          this.$jquery('.fT1DebitCommissionBymillion').val(t1UnionDebit)
          this.$jquery('.fT1CreditCommissionBymillion').val(t1UnionCredit)

          this.$jquery('.fT0DebitCommissionBymillion').val(t0UnionDebit)
          this.$jquery('.fT0CreditCommissionBymillion').val(t0UnionCredit)

          this.$jquery('.unionLowerDivideCent').val(unionLower)
          this.$jquery('.fT1UnionpayDebitMaxCharge').val(t1UnionpayDebitMaxCharge)

          this.$jquery('.fT1BelowDebitCommissionBymillion').val(t1BelowUnionDebitRate)
          this.$jquery('.fT0BelowDebitCommissionBymillion').val(t0BelowUnionDebitRate)
          this.$jquery('.fT1BelowCreditCommissionBymillion').val(t1BelowUnionCreditRate)
          this.$jquery('.fT0BelowCreditCommissionBymillion').val(t0BelowUnionCreditRate)

          if (rateInfo.fExtraData) {
            this.extraFeeRate = this.$options.data().extraFeeRate
            const extraFeeRate = JSON.parse(rateInfo.fExtraData)
            console.log(extraFeeRate)
            for (const item in this.extraFeeRate.alipay) {
              if (typeof (extraFeeRate.alipay[item]) === 'number') {
                this.$jquery('.' + 'alipay_' + item).val((extraFeeRate.alipay[item]) / 10000)
              } else {
                this.$jquery('.' + 'alipay_' + item).val('')
              }
            }
            for (const item in this.extraFeeRate.wechat) {
              if (typeof (extraFeeRate.wechat[item]) === 'number') {
                this.$jquery('.' + 'wechat_' + item).val((extraFeeRate.wechat[item]) / 10000)
              } else {
                this.$jquery('.' + 'wechat_' + item).val('')
              }
            }
          } else {
            this.extraFeeRate = this.$options.data().extraFeeRate

            for (const item in this.extraFeeRate.alipay) {
              this.$jquery('.' + 'alipay_' + item).val('')
            }
            for (const item in this.extraFeeRate.wechat) {
              this.$jquery('.' + 'wechat_' + item).val('')
            }
          }
        }
      } else {
        if (this.ruleType === 0) {
          this.baseInfo.fLowerDivideCent = ''
        } else {
          this.$jquery('.t1DebitCommission').val('')
          this.$jquery('.t1DebitMaxFee').val('')
          this.$jquery('.t1CreditCommission').val('')
          this.$jquery('.t1OverSeasCommission').val('')
          this.$jquery('.t1WeixinCommission').val('')
          this.$jquery('.t1AlipayCommission').val('')
          this.$jquery('.posLowerDivideCent').val('')

          this.$jquery('.t0DebitCommission').val('')
          this.$jquery('.t0CreditCommission').val('')
          this.$jquery('.t0OverSeasCommission').val('')
          this.$jquery('.t0FixFee').val('')
          this.$jquery('.t0WeixinCommission').val('')
          this.$jquery('.t0AlipayCommission').val('')
          this.$jquery('.scanLowerDivideCent').val('')

          this.$jquery('.fT1DebitCommissionBymillion').val('')
          this.$jquery('.fT1CreditCommissionBymillion').val('')
          // this.$jquery(".fT1OverseasCommissionBymillion").val(t1UnionOverseas)
          this.$jquery('.fT0DebitCommissionBymillion').val('')
          this.$jquery('.fT0CreditCommissionBymillion').val('')
          // this.$jquery(".fT0OverseasCommissionBymillion").val(t0UnionOverseas)
          this.$jquery('.unionLowerDivideCent').val('')
          this.$jquery('.fT1UnionpayDebitMaxCharge').val('')

          this.$jquery('.fT1BelowDebitCommissionBymillion').val('')
          this.$jquery('.fT0BelowDebitCommissionBymillion').val('')
          this.$jquery('.fT1BelowCreditCommissionBymillion').val('')
          this.$jquery('.fT0BelowCreditCommissionBymillion').val('')
          for (const item in this.extraFeeRate.alipay) {
            this.$jquery('.' + 'alipay_' + item).val('')
          }
          for (const item in this.extraFeeRate.wechat) {
            this.$jquery('.' + 'wechat_' + item).val('')
          }
        }
      }
    },
    /**
       * 新增/编辑模板费率table合并行方法
       */
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === 'D+0单笔手续费') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    /**
       * 新增/编辑模板费率table合并行方法-扫码费率特殊处理
       */
    editTemplateTableSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 13,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === '类型') {
        if (rowIndex === 0) {
          return {
            rowspan: 8,
            colspan: 1
          }
        } else if (rowIndex === 8) {
          return {
            rowspan: 5,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    clickExtraRate (type, key) {
      if (this.defaultDataParam.extraFeeRate[type][key] === '') {
        this.$message({
          showClose: true,
          message: '上级代理商未开通此通道交易，无法设置费率',
          type: 'warning'
        })
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
    this.getBank()
    this.getPro()
    this.getAgentLevel()
    this.getUserInfo()
    this.getTemplateList()
    // this.initRouters();
  },
  watch: {
    '$route' (to, from) {
      this.getList()
    }
  },
  computed: {
    agentLevel () {
      const userInfo = this.$store.getters.userInfo
      return userInfo.userEntity.fAgentLevel
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .demo-form-inline {
    display: inline-block;
    float: right;
  }

  .btm-action {
    margin: 20px 0;
    text-align: center;
    .el-select {
      display: none;
      position: relative;
    }
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  .tab-tag{
    height:0;
    padding: 0;
    line-height: 0;
    background: transparent;
  }
  .dsn{
    display: none;
  }
  .submit{
    margin-left: 10px;
  }
  .check{
    margin-left: 2%;
  }
  /* 费率表单 */

  .posListTittle{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 15%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }
  .posList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    // border-bottom: 1px solid #ccc;
    li{
      width: 15%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }
  .lastPosList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 15%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }

  .scanListTittle{
    width: 50%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-top: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    // input {border: 0;width: 75%; text-align: center;}
    //  .el-input__inner {border: 0; text-align: center;}

  }
  .scanList{
    width: 50%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    //border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input:last-child {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}

  }
  .lastScanList{
    width: 50%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    li{
      width: 24%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;
    }
    li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
    li:first-child{ border-left: 1px solid #ccc;}
    input:last-child {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }

  .unionMerListTittle{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    //border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    li:first-child{ border-left: 1px solid #ccc;}

  }
  .unionMerList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    //border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }
  .lastUnionMerList{
    width: 100%;
    padding-left: 0;
    list-style: none;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    //border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    li{
      width: 19%;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #ccc;}
    li:last-child{ border-right: 0;}
    input {border: 0;width: 75%; text-align: center;}
    .el-input__inner {border: 0; text-align: center;}
  }
  .form-input {
    width: 300px;
  }
  .el-table input,.scanLowerDivideCent{
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: calc(100% - 20px);
    text-align: center;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    +span{
      height: 30px;
      line-height: 30px;
      margin-left: 5px;
    }
    &:disabled{
      background-color: #F5F7FA;
      border-color: #E4E7ED;
      color: #C0C4CC;
      cursor: not-allowed;
    }
  }
  .el-input{
    span{
      line-height: 40px;
      color: #606266;
      font-size: inherit;
    }
  }
  .editDialog {
    h3 {
      margin: 10px 0;
    }
  }
  .two-table {
    display: flex;
    .cutom-table {
      margin-right: 60px;
      .row {
        display: flex;
        align-items: center;
        &.title {
          background: #F5F7FA;
        }
        .item {
          padding: 10px;
          width: 160px;
          &.left {
            width: 150px;
          }
        }
      }
    }
  }
  .row {
    display: flex;
    .item {
      padding: 8px;
      width: 180px;
      box-sizing: content-box;
      text-align:center;
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      &:first-child {
        border-left: 1px solid #EBEEF5;
      }
    }
  }
</style>
<style lang="scss">
  .infoAgentForm{
    .el-collapse-item__header{
      border-left: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
      padding-left: 20px;
      line-height: 1;
      background: #F5F7FA;
      color: #909399;
    }
    .el-collapse-item__wrap{
      border-bottom: none;
    }
    .el-collapse-item__arrow {
      margin: 0 8px 0 10px;
    }
  }
</style>
